import React, { useState, useContext, useEffect } from 'react';
import { AccessContext } from '../../providers/AccessProvider';
import CircularProgress from '@mui/material/CircularProgress';

export const SubscribedCheck = (props) => {
	const { hasAccess } = useContext(AccessContext);
	const states = {
		LOADING: 0,
		NOT_SUBSCRIBED: 1,
		SUBSCRIBED: 2,
	};

	const { subscribed, notSubscribed } = props;
	const [view, setView] = useState(states.LOADING);

	const getView = () => {
		switch (view) {
			case states.LOADING:
			default:
				return <CircularProgress />;
			case states.NOT_SUBSCRIBED:
				return notSubscribed;
			case states.SUBSCRIBED:
				return subscribed;
		}
	};

	useEffect(() => {
		if (hasAccess) {
			setView(states.SUBSCRIBED);
		} else {
			setView(states.NOT_SUBSCRIBED);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hasAccess]);

	return getView();
};
